var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconVoice = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#455CC7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1636_1927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1636_1927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0894 10.9262C14.6842 10.0407 14.2582 10.0204 13.8738 10.0102C13.5622 10 13.1985 10 12.8349 10C12.4713 10 11.8895 10.1323 11.3908 10.6616C10.8921 11.1909 9.5 12.4733 9.5 15.0892C9.5 17.6948 11.4428 20.219 11.7129 20.5753C11.983 20.9315 15.4634 26.4583 20.9593 28.5856C25.5305 30.3566 26.4655 30.0004 27.4525 29.9088C28.4395 29.8172 30.6524 28.6263 31.1095 27.3845C31.5562 26.1428 31.5562 25.0843 31.4212 24.8603C31.2861 24.6364 30.9225 24.5041 30.3823 24.2395C29.842 23.9748 27.1824 22.6923 26.6837 22.5091C26.185 22.3361 25.8214 22.2445 25.4682 22.7738C25.1045 23.303 24.0656 24.4939 23.754 24.8501C23.4423 25.2064 23.1202 25.2471 22.58 24.9825C22.0397 24.7178 20.2944 24.158 18.2269 22.3463C16.6166 20.9417 15.5257 19.2012 15.214 18.6719C14.9024 18.1426 15.1829 17.8577 15.453 17.593C15.692 17.3589 15.9932 16.9721 16.2634 16.6668C16.5335 16.3614 16.627 16.1375 16.8036 15.7813C16.9802 15.425 16.8971 15.1197 16.762 14.8551C16.627 14.6006 15.5673 11.9746 15.0894 10.9262Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconVoice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-voice.d34dbe52.svg";
export { ForwardRef as ReactComponent };